import { useNavigate } from "react-router";

/**
 * „Zurück“ (Systemwort, oberflaeche.md §1.3): zur vorigen Ansicht; wurde die Ansicht direkt geöffnet (keine vorige
 * Ansicht dieser App, z. B. aus einer Benachrichtigung), zu `ersatz`.
 */
export function useZurueck(ersatz: string): () => void {
  const navigate = useNavigate();
  return () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) navigate(-1);
    else navigate(ersatz, { replace: true });
  };
}
